import { PAGES } from '@/constants/pages';
import { getUrlParams } from '@/utils/url';

export default {
  computed: {
    isPageOrdersRetail() {
      return this.$route.name === PAGES.orders.retail.name;
    },

    isPageOrdersDealer() {
      return this.$route.name === PAGES.orders.dealer.name;
    },

    isPageOrdersSupplier() {
      return this.$route.name === PAGES.orders.supplier.name;
    },

    isPageNewOrder() {
      return this.$route.name === PAGES.orders.new_order.name;
    },

    isPageNewOrderZgi() {
      return this.isPageNewOrder && this.$route.query?.tab === 'zgi';
    },

    isDealerAmigo() {
      return this.$store?.getters?.['user/getDealer']?.parent_id === 1;
    },

    // дилер верхнего уровня
    isDealerTopLevel() {
      return this.$store?.getters?.['user/getDealer']?.level === 0;
    },

    isDealerParentPostMessage() {
      if (window?.parent) {
        const urlParams = getUrlParams(location?.search || '');

        const hide = urlParams.get('hide');
        const useExternal = urlParams.get('ue');

        if (hide === 't' && useExternal == 1) {
          return true;
        }
      }

      return false;
    },
  },
};
